import { gql } from '@apollo/client';

export const FLIPPER_ENABLED = gql`
query FLIPPER_ENABLED($feature: String!, $originatorId: ID!, $oriId: ID!){
  flipperEnabled(feature: $feature, originatorId: $originatorId, oriId: $oriId) {
    enabled
    feature
    oriId
  }
}`;

